import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  trackPageView,
  trackEvent,
  setUserProperties,
} from "../utils/analytics";

/**
 * Hook to automatically track page views and provide analytics functions
 */
export const useAnalytics = () => {
  const location = useLocation();

  // Automatically track page views
  useEffect(() => {
    trackPageView(location.pathname);
  }, [location.pathname]);

  return {
    trackEvent,
    trackPageView: (page: string) => trackPageView(page),
    setUserProperties,
    trackFeatureUsage: (feature: string) => {
      trackEvent({
        action: "feature_used",
        category: "engagement",
        label: feature,
        customParameters: { feature_name: feature },
      });
    },
    trackError: (error: string, context?: string) => {
      trackEvent({
        action: "exception",
        category: "error",
        label: error,
        customParameters: { description: error, context },
      });
    },
  };
};